import { render, staticRenderFns } from "./RemovePromotionCall.vue?vue&type=template&id=beed856e&"
import script from "./RemovePromotionCall.vue?vue&type=script&lang=js&"
export * from "./RemovePromotionCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports